import { useNavigate } from "react-router-dom";
import CancelButton from "../components/cancelButton/CancelButton";

const BackToECommerceListButton = () => {
  const navigate = useNavigate();
  return <CancelButton onClick={() => navigate("/e-commerce")}>Wróć do listy</CancelButton>;
};

export default BackToECommerceListButton;
